import axios from 'axios'

export const submitSaveNotificationsForm = ({ emailNotifications }) => {
  return axios.put('/user/email-notifications', {
    emailNotifications,
  })
}

export const unsubscribeEmailNotifications = ({ id, type, hash }) => {
  return axios.post('/user/unsubscribe-email-notifications', {
    id,
    type,
    hash,
  })
}
